import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {performSimpleActionForTable} from 'modules/data/data-actions';
import {selectTableSelectedRowKeys} from 'modules/data/data-selectors';
import {ERequestType} from 'shared/types/requests';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

export const ButtonActionForRows: FC<ITableActionProps> = ({
    wrapper,
    meta,
    ...props
}: ITableActionProps) => {
    const entityName = meta?.entityName || '';
    const referenceUrl = meta?.referenceUrl || '';
    const {requestType, isJsonRequest} = meta;
    const dispatch = useDispatch();
    const selectedRowKeys = useAppSelector(selectTableSelectedRowKeys(entityName)) || [];
    const handleClick = () => {
        dispatch(
            performSimpleActionForTable(
                entityName,
                referenceUrl,
                requestType || ERequestType.DELETE,
                {selectedRowKeys},
                isJsonRequest,
            ),
        );
    };
    const Component = wrapper || ActionButton;

    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!selectedRowKeys.length}
        >
            {meta.actionTitle}
        </Component>
    );
};
